import React from "react";

interface Props {
  dataTest: string;
  onClick: any;
}

export default ({ dataTest, onClick }: Props) => {
  return (
    <div
      className="clickable update-rank text-cell double-height"
      data-test={dataTest}
      onClick={onClick}
    >
      +
    </div>
  );
};
